import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	invalidDateFormat: {
		id: 'issue-time-estimate.edit.invalid-date-format',
		defaultMessage: 'Please enter date in the correct format',
		description: 'Error message when token is missing',
	},
	warning: {
		id: 'issue-time-estimate.edit.warning',
		defaultMessage: 'warning',
		description: 'Warning message when time estimate is exceeded',
	},
	timeLoggedExceeded: {
		id: 'issue-time-estimate.edit.time-logged-exceeded',
		defaultMessage: 'Time logged has exceeded the limit',
		description: 'Example, if time spent exceeds the original estimate',
	},
	ariaLabel: {
		id: 'issue-time-estimate.edit.aria-label',
		defaultMessage: 'Enter the estimated time',
		description: 'Accessible name for the Time Estimate field',
	},
});
